import { motion } from "framer-motion";
import "./Hero.scss";

const heroStats = [
  {
    icon: "/assets/images/players.png",
    title: "2–4 Players",
    text: "Balanced at every count"
  },
  {
    icon: "/assets/images/time.png",
    title: "45 Minutes",
    text: "Fast strategy experience"
  },
  {
    icon: "/assets/images/peace-flag.png",
    title: "Peace Flags",
    text: "Tighter 2–3 player maps"
  },
  {
    icon: "/assets/images/playtesters.png",
    title: "200+ Playtesters",
    text: "Refined through real feedback"
  }
];

export default function Hero() {
  return (
    <section
      className="hero"
      id="top"
      style={{
        "--hero-bg-image": "url('/assets/images/hero-bg.webp')",
        "--hero-board-image": "url('/assets/images/hero-board1.webp')",
        "--hero-cards-image": "url('/assets/images/cards.webp')",
        "--hero-flags-image": "url('/assets/images/flags.webp')"
      }}
    >
      <div className="hero__background" />
      <div className="hero__overlay" />

      <div className="hero__content">
        <motion.span
          className="hero__eyebrow"
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .5 }}
        >
          A territory-control game where every conquest matters
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 34 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .7, delay: .08 }}
        >
          The Board Becomes
          <span>Your</span>
          <em>Engine.</em>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .7, delay: .16 }}
        >
          Kotam: Conquest blends territory control and engine building in a 45-minute strategy game where every captured building can shape your next move. Build influence, use powerful resources, and adapt to a different setup every game.
        </motion.p>

        <motion.div
          className="hero__actions"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .7, delay: .24 }}
        >
          <a className="btn btn-primary" href="#signup">Join Early Access</a>
          <a className="btn btn-secondary" href="#features">See What Makes It Different</a>
        </motion.div>

        <motion.div
          className="hero__stats"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .7, delay: .32 }}
        >
          {heroStats.map((stat) => (
            <div className="hero__stat-card" key={stat.title}>
              <img
                src={stat.icon}
                alt=""
                className="hero__stat-icon"
                aria-hidden="true"
              />
              {/* <span className="hero__stat-icon" aria-hidden="true">{stat.icon}</span> */}
              <div>
                <strong>{stat.title}</strong>
                <small>{stat.text}</small>
              </div>
            </div>
          ))}
        </motion.div>
      </div>

      <motion.div
        className="hero__visual"
        initial={{ opacity: 0, scale: .94, rotate: -2 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ duration: .8, delay: .2 }}
      >
        <div className="hero__main-image" />
        {/* <div className="hero__mini hero__mini--cards" />
        <div className="hero__mini hero__mini--flags" /> */}
        <div className="hero__badge">★★★★★ Playtested by 200+ gamers</div>
      </motion.div>
    </section>
  );
}
